<template>
  <div class="input-group" :class="inputGroupClass" v-tap.prevent="{ methods : focus }">
    <div class="input-group_prepend" v-if="$slots.prepend">
      <slot name="prepend"></slot>
    </div>

    <input class="input_inner" @blur="handleBlur" :style="{height: height+'px'}" type="text" name="" :maxlength="maxlength" :value="inpuValue" @input="handleInput" :placeholder="placeholder">
    <input type="hidden">
    <div class="input-group_append" v-if="$slots.append">
      <slot name="append"></slot>
    </div>
  </div>
</template>

<script>
  import utils from '../../utils/index.js'
  const search = utils.getSearch();
  const {from = ''} = search;
  const isWindowsAio = from.toLocaleUpperCase() === 'windowsAio'.toLocaleUpperCase();

  export default {
    name: 'cjm-apc-input',
    data(){
      return {
        inpuValue: this.value,
        inputGroupClass: {
          'input-group-prepend': this.$slots.prepend,
          'input-group-append': this.$slots.append
        }
      }
    },
    watch: {
      value(val){
        this.inpuValue = val;
      }
    },
    methods: {
      focus(params){
        this.$el.querySelector('input.input_inner').focus();
      },
      handleBlur(event){
        this.$emit('blur');
      },
      handleInput(event) {
        let value = event.target.value;
        if (!isWindowsAio) {
          value = value.replace(/[^0-9a-zA-Z]/ig, '');
        }
        this.inpuValue = value;
        event.target.value = value;
        this.$emit('queryInput', value);
      }
    },
    props: {
      value: {
        type: [String, Number],
        default: ''
      },
      placeholder: {
        type: String,
        default: '请输入溯源码'
      },
      maxlength: Number,
      height: {
        type: [String, Number],
        default: ''
      }
    }
  }
</script>

<style lang="less">
  @import '../../assets/less/base.less';

  @border-radius: 8px;
  .input-group {
    height: 100%;
    display: inline-table;
    border-collapse: separate;
  }

  .input-group_prepend {
    display: table-cell;
    width: 1%;
    font-size: 0;
    vertical-align: middle;
  }

  .input_inner {
    display: table-cell;
    width: 100%;
    padding: 0 10px;
    font-size: @font-size-normal;
    vertical-align: middle;
    border: 1px solid @color-gray;
    outline: none;
    border-radius: @border-radius;
    background: #fff;
  }

  .input-group-prepend .input_inner {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .input-group-prepend .input-group_prepend {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
</style>



// WEBPACK FOOTER //
// input.vue?3dbe536c